'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TEXT_TRANSFORM = exports.TEXT_TRANSFORM = {
  NONE: 0,
  LOWERCASE: 1,
  UPPERCASE: 2,
  CAPITALIZE: 3
};

var parseTextTransform = exports.parseTextTransform = function parseTextTransform(textTransform) {
  switch (textTransform) {
    case 'uppercase':
      return TEXT_TRANSFORM.UPPERCASE;

    case 'lowercase':
      return TEXT_TRANSFORM.LOWERCASE;

    case 'capitalize':
      return TEXT_TRANSFORM.CAPITALIZE;
  }

  return TEXT_TRANSFORM.NONE;
};